export default __webpack_public_path__ + "static/media/eatingtimes_4.54582f2e.jpg";